
'use strict';

const $ = require('jquery');
require('jquery-validation');
$.extend($.validator.messages,  window.messages);


const formData = function () {

    const ajaxInjection = require('./../modules/ajaxInjector.js');

    const formdata = function (formclass, url, methode, element, template, callback, errorCallback) {

        $.validator.methods.email = function( value, element ) {
            return this.optional( element ) || /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/.test( value );
        };

        $(formclass).validate({
            rules:{
                password:{
                    required:function(){
                        if($("#customer-account").length > 0 && $("#customer-account").is(':checked')){
                            return true;
                        }else{
                            return false;
                        }
                    },
                    minlength:8,
                },
                password_confirm:{
                    required:function(){
                        if($("#customer-account").length > 0 && $("#customer-account").is(':checked')){
                            return true;
                        }else{
                            return false;
                        }
                    },
                    equalTo:"#customer_password"
                },
            },
            errorElement: 'small',

            errorPlacement: function(error, element) {
                if (element.attr('type') === 'radio') {
                    error.appendTo(element.parent().parent().parent());
                } else {
                    error.appendTo(element.parent());
                }
            },

            showErrors: function () {
                const validateEvent = new CustomEvent('formValidated', {
                    detail: {
                        valid: false
                    }
                });

                document.querySelector(formclass).dispatchEvent(validateEvent);
                this.defaultShowErrors();
            },

            success: function (label) {
                const validateEvent = new CustomEvent('formValidated', {
                    detail: {
                        valid: true
                    }
                });

                document.querySelector(formclass).dispatchEvent(validateEvent);
            },

            onkeyup: function(element) {
                if ( element.dataset.keyup ) {
                    $(element).valid();
                }
            },

            submitHandler: function () {

                const validateEvent = new CustomEvent('formSubmitted', {});

                document.querySelector(formclass).dispatchEvent(validateEvent);
                let data = {};

                if($('#customer-country').val() !== undefined)
                {
                    data.country = $('#customer-country').val();
                }
                $('.message').hide();

                if($('#customer-delivery-country').val() !== undefined)
                {
                    data.deliveryCountry = $('#customer-delivery-country').val();
                }

                $.each($(formclass), function (index, value) {
                    $.each(value, function (index2, value2) {
                        if ($(value2).attr('type') === 'text' || $(value2).attr('type') === 'password' || $(value2).attr('type') === 'hidden' || $(value2).attr('type') === 'email') {
                            data[$(value2).attr('name')] = $(value2).val();
                        }

                        if ($(value2).attr('type') === 'radio' && $(value2).is(':checked')) {

                            data[$(value2).attr('name')] = $(value2).attr('value');
                        }
                        if ($(value2).attr('type') === 'checkbox') {

                            data[$(value2).attr('name')] = ($(value2).is(':checked') === true ? 1 : 0);
                        }
                        if ($(value2).is('textarea')) {
                            data[$(value2).attr('name')] = $(value2).val();
                        }
                    });
                });

                ajaxInjection.request(url, methode, data, element, template)
                    .then(function (response) {
                        message(response);

                        if(callback !== undefined){
                            callback(response, data);
                        }
                    })
                    .catch(function(response) {
                        if (errorCallback) {
                            errorCallback(response,data);
                        }
                    });
            }
        });

    };

    const message =  function( response ){
        if ( response && response.message ) {
            $('.message').show().text(response.message);
            $( ".customer-form input" ).val('');
        } else {
            $.each(response , function( index, value){

                $( ".customer-form input[name='"+index+"']" ).addClass('error').after(function() {
                    return '<small class="error" style="">'+value+'</small>';
                });
            });
        }

        if(response.message === undefined ){
            $.each(response , function( index, value){

                $( ".customer-form input[name='"+index+"']" ).addClass('error').after(function() {
                    return '<small class="error" style="">'+value+'</small>';
                });
            });
        }else{
            $('.message').show().text(response.message);
            $( ".customer-form input" ).val('');
        }
    };

    return {
        formdata: formdata
    };
};

module.exports = new formData();
